const API = 'StockDiamondToDiamondOvertones';

export const API_STOCK_DIAMOND_TO_DIAMOND_OVERTONES = {
  POST_BULK: `${API}/CreateStockDiamondToDiamondOvertoneBulk`,
};
